import React from "react";

const CurrentActiveBtn = ({ state }) => {
  const statesArray = [
    {
      state: true,
      text: "فعال",
      className: "px-[10px] py-1 rounded-md text-success-60 bg-success-10 text-title-sm-regular",
    },
    {
      state: false,
      text: "غیرفعال",
      className: "text-error-90 bg-error-20 px-[10px] py-1 rounded-md  text-title-sm-regular",
    },
  ];

  const activeItem = statesArray.find((item) => item.state === state);

  return <div className={activeItem ? activeItem.className : ""}>{activeItem?.text}</div>;
};

export default CurrentActiveBtn;
